export enum ChildCallbackTypes {
    SET_FILTER_MENU,
    SET_FILTER_VALUE
}